import type { CSSProperties } from 'react'

/* Purple - https://tailwindcss.com/docs/colors#default-color-palette-reference */
export const scenarioStyles = {
  '--color-primary': 'var(--color-teal-500)',
  '--color-primary-50': 'var(--color-teal-50)',
  '--color-primary-100': 'var(--color-teal-100)',
  '--color-primary-200': 'var(--color-teal-200)',
  '--color-primary-300': 'var(--color-teal-300)',
  '--color-primary-400': 'var(--color-teal-400)',
  '--color-primary-500': 'var(--color-teal-500)',
  '--color-primary-600': 'var(--color-teal-600)',
  '--color-primary-700': 'var(--color-teal-700)',
  '--color-primary-800': 'var(--color-teal-800)',
  '--color-primary-900': 'var(--color-teal-900)',
  '--color-primary-950': 'var(--color-teal-950)',
  '--amaze-focus':
    '0 0 0 2px var(--color-teal-500), inset 0 0 0 4px color-mix(in srgb, var(--color-amaze-paper), transparent 25%)',
  '--amaze-focus-dark':
    '0 0 0 2px var(--color-teal-500), inset 0 0 0 4px color-mix(in srgb, var(--color-amaze-paperDark), transparent 25%)',
} as CSSProperties
